/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Sol_Agensi_D1dInputs */

const en_mk_sol_agensi_d1d = /** @type {(inputs: Mk_Sol_Agensi_D1dInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The account manager turns the client’s request into one issue with a due date and a client label. Every revision sticks to it, not to a chat scroll.`)
};

const id_mk_sol_agensi_d1d = /** @type {(inputs: Mk_Sol_Agensi_D1dInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Akun menempelkan permintaan klien jadi satu issue dengan tenggat dan label klien. Semua revisi menempel di situ, bukan di gulungan chat.`)
};

/**
* | output |
* | --- |
* | "The account manager turns the client’s request into one issue with a due date and a client label. Every revision sticks to it, not to a chat scroll." |
*
* @param {Mk_Sol_Agensi_D1dInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_sol_agensi_d1d = /** @type {((inputs?: Mk_Sol_Agensi_D1dInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Sol_Agensi_D1dInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_sol_agensi_d1d(inputs)
	return en_mk_sol_agensi_d1d(inputs)
});